export const isCountryCodeValid = (countryCode?: string): boolean => {
    if (!countryCode || !countryCode.startsWith('+')) {
        return false;
    }
    if (countryCode.startsWith('+') && !isFinite(Number(countryCode.replace('+', '')))) {
        return false;
    }
    return true;
};
